import React, { useState, useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import SearchCanvas from "../pages/canvas/SearchCanvas";
import { Container, Nav } from "react-bootstrap";
import { Menu, User, Search, Heart, ShoppingBag, X } from "lucide-react";
import { CategoryContext } from "../context/CategoryContext";

function Header() {
  const [searchText, setSearchText] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);
  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const { categories } = useContext(CategoryContext);
  const [openId, setOpenId] = useState(null);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  const closeMobileMenu = () => {
  document.querySelector("#mobileMenu .icon-close-popup")?.click();
};

  if (!config) return null;

  return (
    <>
      <header className="custom-header-wrapper">
        {/* MARQUEE TOPBAR */}
        <div className="custom-topbar">
          <div className="marquee-track">
            <div className="marquee-content">
              <span>Free Express Shipping On Orders Over ₹599</span>
              <span>Make Every Gift Unforgettable With Personalization</span>
              <span>Free Express Shipping On Orders Over ₹599</span>
              <span>Make Every Gift Unforgettable With Personalization</span>
            </div>
            <div className="marquee-content" aria-hidden="true">
              <span>Free Express Shipping On Orders Over ₹599</span>
              <span>Make Every Gift Unforgettable With Personalization</span>
              <span>Free Express Shipping On Orders Over ₹599</span>
              <span>Make Every Gift Unforgettable With Personalization</span>
            </div>
          </div>
        </div>

        {/* MAIN HEADER ROW */}
        <div className="custom-header-main-layer">
          <Container fluid className="px-md-5 px-3">
            <div className="custom-header-flex">
              {/* LEFT - Search */}
              <div className="custom-header-left">
                {/* <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#searchOffcanvas"
                  className="header-icon-btn d-none d-lg-flex"
                >
                  <Search size={18} />
                  <span>Search</span>
                </button> */}
                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#mobileMenu"
                  aria-label="Menu"
                  className="header-icon-btn icon-only d-lg-none"
                >
                  <Menu size={22} />
                </button>

                <Nav.Link
                  as={Link}
                  to="/shop"
                  className="custom-nav-item d-none d-lg-block"
                >
                  Shop
                </Nav.Link>
              </div>

              {/* CENTER - Logo */}
              <div className="custom-header-center-logo">
                <Link to="/" className="custom-header-logo">
                  <img src={config?.logo} alt="logo" />
                </Link>
              </div>

              {/* RIGHT - Account / Search(mobile) / Wishlist / Cart */}
              <div className="custom-header-right">
                <Link
                  to={isLoggedIn ? "/users/dashboard" : "/users/login"}
                  className="header-icon-btn d-none d-lg-flex"
                >
                  <User size={18} />
                  <span>Account</span>
                </Link>

                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#searchOffcanvas"
                  className="header-icon-btn icon-only d-lg-none"
                >
                  <Search size={20} />
                </button>

                <Link to="/wishlist" className="header-icon-btn icon-only">
                  <Heart size={18} />
                </Link>

                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#shoppingCartCanvas"
                  className="header-icon-btn icon-only cart-btn"
                >
                  <ShoppingBag size={18} />
                  {cartItems.length > 0 && (
                    <span className="cart-count">{cartItems.length}</span>
                  )}
                </button>
              </div>
            </div>
          </Container>
        </div>

        {/* NAV ROW */}
        <div className="custom-header-nav-row d-none d-lg-block">
          <Container fluid className="px-md-5 px-3">
            <Nav className="justify-content-center custom-nav-center">
              <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#searchOffcanvas"
                  className="header-icon-btn d-none d-lg-flex"
                >
                  <Search size={18} />
                  {/* <span>Search</span> */}
                </button>
              <Nav.Link as={Link} to="/" className=" ms-5 custom-nav-item">
                Home
              </Nav.Link>
               

              <div className="custom-nav-dropdown">
                <Nav.Link as={Link} to="/#" className="custom-nav-item">
                  About{" "}
                  <i
                    className="fas fa-chevron-down ms-1"
                    style={{ fontSize: "10px" }}
                  ></i>
                </Nav.Link>
                <div className="custom-dropdown-menu">
                  <Link to="/about-us" className="custom-dropdown-item">
                    About Us
                  </Link>
                  <Link to="/blog" className="custom-dropdown-item">
                    Blogs
                  </Link>
                 
                </div>
              </div>

              {categories.map((cat) => (
                <div className="custom-nav-dropdown" key={cat._id}>
                  <Nav.Link
                    as={Link}
                    to={`/categories/${cat.slugPath}`}
                    className="custom-nav-item"
                  >
                    {cat.name}
                  </Nav.Link>

                  {cat.children && cat.children.length > 0 && (
                    <div className="custom-dropdown-menu">
                      {cat.children.map((sub) => (
                        <Link
                          key={sub._id}
                          to={`/categories/${sub.slugPath}`}
                          className="custom-dropdown-item"
                        >
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              <Nav.Link as={Link} to="/contact-us" className="custom-nav-item">
                Contact
              </Nav.Link>
              

              {/* <Nav.Link as={Link} to="/enquiry-form" className="custom-nav-item">
                Bulk Enquiry
              </Nav.Link> */}
            </Nav>
          </Container>
        </div>
      </header>

      {/* SEARCH OFFCANVAS */}
      <div
        className="offcanvas offcanvas-top custom-search-offcanvas"
        id="searchOffcanvas"
        tabIndex="-1"
      >
        <div className="search-offcanvas-inner">
          <button
            className="search-close-btn"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setSearchText("");
              setShowSearchModal(false);
            }}
          >
            <X size={22} />
          </button>

          <SearchCanvas
            isOpen={showSearchModal}
            searchText={searchText}
            setSearchText={(val) => {
              setSearchText(val);
              setShowSearchModal(true);
            }}
          />
        </div>
      </div>

      {/* CART OFFCANVAS */}
      <div
        className="offcanvas offcanvas-end custom-cart-offcanvas"
        id="shoppingCartCanvas"
      >
        <CartCanvas />
      </div>

      {/* LOGIN OFFCANVAS */}
      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="loginOffCanvas"
      >
        <LoginCanvas />
      </div>

      {/* REGISTER OFFCANVAS */}
      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="registerOffCanvas"
      >
        <RegisterCanvas />
      </div>

      {/* MOBILE MENU OFFCANVAS */}
      <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
        <button
          className="icon-close icon-close-popup"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
        <div className="mb-canvas-content">
          <div className="mb-body">
            <div className="mb-content-top">
              <ul className="nav-ul-mb" id="wrapper-menu-navigation">
                <li className="nav-mb-item">
                  <Link to="/" className="mb-menu-link text-decoration-none">
                    Home
                  </Link>
                </li>

                <li className="nav-mb-item">
                  <Link to="/shop" className="mb-menu-link text-decoration-none">
                    Shop
                  </Link>
                </li>

                <li className="nav-mb-item">
                  <div
                    className="mb-menu-link d-flex justify-content-between align-items-center"
                    onClick={() => handleToggle("about-mb")}
                    style={{ cursor: "pointer" }}
                  >
                    About
                    <span className="plus-minus-icon">
                      {openId === "about-mb" ? "-" : "+"}
                    </span>
                  </div>

                  {openId === "about-mb" && (
                    <div className="dropdown-menu show border-0 ps-2 bg-transparent">
                      <Link to="/about-us" className="dropdown-item py-2">
                        About Us
                      </Link>
                      <Link to="/blog" className="dropdown-item py-2">
                        Blogs
                      </Link>
                    </div>
                  )}
                </li>

                {categories.map((cat) => (
  <li className="nav-mb-item" key={cat._id}>
    <div className="mb-menu-link d-flex justify-content-between align-items-center">
      <Link
        to={`/categories/${cat.slugPath}`}
        className="text-decoration-none flex-grow-1"
        style={{ color: "inherit" }}
        onClick={closeMobileMenu}
      >
        {cat.name}
      </Link>

      {cat.children?.length > 0 && (
        <button
          type="button"
          className="plus-minus-icon border-0 bg-transparent px-2"
          aria-label={`Toggle ${cat.name}`}
          onClick={() => handleToggle(cat._id)}
        >
          {openId === cat._id ? "-" : "+"}
        </button>
      )}
    </div>

    {cat.children?.length > 0 && openId === cat._id && (
      <div className="dropdown-menu show border-0 ps-2 bg-transparent">
        {cat.children.map((sub) => (
          <Link
            key={sub._id}
            to={`/categories/${sub.slugPath}`}
            className="dropdown-item"
            onClick={closeMobileMenu}
          >
            {sub.name}
          </Link>
        ))}
      </div>
    )}
  </li>
))}

                <li className="nav-mb-item">
                  <Link
                    to="/contact-us"
                    className="mb-menu-link "
                    style={{ textDecoration: "none" }}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="mb-other-content">
              <div className="group-icon">
                {!isLoggedIn ? (
                  <Link to="/users/login" className="shop-btn">
                    <User size={16} className="me-2" /> Login
                  </Link>
                ) : (
                  <Link to="/users/dashboard" className="shop-btn">
                    <User size={16} className="me-2" /> Dashboard
                  </Link>
                )}
              </div>
              {/* <div className="mb-contact mb-0 border-bottom">
                <p>
                  Address:
                  <span className="ms-1">
                    {[
                      config?.address?.addressLine,
                      config?.address?.district,
                      config?.address?.state,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                    {config?.address?.pincode
                      ? ` - ${config?.address.pincode}`
                      : ""}
                  </span>
                </p>
              </div> */}
              {/* <ul className="pt-3">
                <li>
                  Email:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`mailto: ${config.email}`}
                    >
                      {config.email}
                    </a>
                  </b>
                </li>
                <li>
                  Phone:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`tel: ${config.phone}`}
                    >
                      +91-{config.phone}
                    </a>
                  </b>
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
